import React from 'react';
import { withStyles } from '@material-ui/core';
import { OutlinedButton } from '@ds/react-components';
import { useParams, useHistory } from 'react-router-dom';

const styles = (theme) => ({
  CancelBtn: {
    marginLeft: '8px',
  },
});

const SuspensionFormCancelButton = (props) => {
  const { isDisabled, classes } = props;

  const history = useHistory();
  const { adfitNo } = useParams();
  const onCancelBtnClick = (e) => {
    e.preventDefault();
    history.push(`/Customers/${adfitNo}/Payments/Suspensions`);
  };
  return (
    <OutlinedButton
      variant="slighter"
      className={classes.CancelBtn}
      onClick={onCancelBtnClick}
      isDisabled={isDisabled}>
      Cancel
    </OutlinedButton>
  );
};

export default withStyles(styles)(SuspensionFormCancelButton);
